angular.module('rjmNg.api').factory 'BulkEdit', [
  "$resource"
  "serviceUrl"
  "Figures"
  "Charts"
  (
    $resource
    serviceUrl
    Figures
    Charts
  ) ->
    (dashboardId) ->

      baseUrl = serviceUrl("/dashboards/#{dashboardId}/bulk-edit")

      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        post: angular.extend {}, defaultParams,
          method: 'POST'

      resource = $resource(baseUrl, {}, actions)

      post: (payload) ->
        promise = resource.post({}, payload).$promise
        promise.then(
          () ->
            Figures.clearCache()
            Charts.clearCache()
        )
        return promise
]
